import React from 'react'
import { localizations } from '@iheartjane/jane-iso-3166'
import { Dropdown } from 'semantic-ui-react'

const options = [
  ...localizations.subdivisions.us
    .map((locale) => ({
      key: `US-${locale.code.toUpperCase()}`,
      value: `US-${locale.code.toUpperCase()}`,
      text: locale.displayName.en,
    }))
    .concat([
      ...localizations.subdivisions.ca.map((locale) => ({
        key: `CA-${locale.code.toUpperCase()}`,
        value: `CA-${locale.code.toUpperCase()}`,
        text: locale.displayName.en,
      })),
    ]),
]

interface Props {
  value: string
  setValue: (v: string) => void
}

const LocaleSpecificSelect = ({ value, setValue }: Props) => {
  return (
    <div id="locale-specific-select" style={{ margin: '15px auto', fontSize: '18px' }}>
      <span>
        View content as:&nbsp;
        <Dropdown
          compact
          inline
          options={options}
          defaultValue={'US-AL'}
          onChange={(_e, { value }) => setValue(value as string)}
          search
        />
      </span>
    </div>
  )
}

export default LocaleSpecificSelect
